<template>
  <div class="pages-container">
    <div v-if="data.index == 'terms-and-conditions'">
      <p><strong>Copyright</strong></p>
      <p>
        All information available through this website is the property of Morningstar Investment
        Management LLC and is protected by copyright and intellectual property laws. All rights
        reserved.
      </p>
      <p>
        You may not reproduce, retransmit, disseminate, sell, publish, broadcast, or circulate the
        information without the express written consent of Morningstar Investment Management LLC.
        You are entitled to use the information for your private, non-commercial use only.
      </p>
      <p><strong>Trademarks</strong></p>
      <p>
        The Morningstar name and logo are registered marks of Morningstar. Marks used in conjunction
        with Morningstar products or services are the property of Morningstar or its subsidiaries.
        All other marks are the property of their respective owners.
      </p>
      <p><strong>Products and Services Offered Through U.S. Subsidiaries</strong></p>
      <p>
        Morningstar Fiduciary Connect is offered by Morningstar Investment Management LLC, a
        registered investment adviser and wholly owned subsidiary of Morningstar, Inc. The products
        and services offered by Morningstar Investment Management are intended for citizens or legal
        residents of the United States or its territories.
      </p>
      <p><strong>Nature of Service</strong></p>
      <p>
        This website contains statements and statistics that have been obtained from sources
        believed to be reliable but are not guaranteed as to accuracy or completeness. References to
        any specific securities or investment advice of any kind do not constitute an offer to buy
        or sell securities. The past performance of an investment or investment strategy cannot
        guarantee its future performance.
      </p>
      <p>
        Unless otherwise provided in a separate agreement, you may use this report only in the
        country in which its original distributor is based. The information, data, analyses and
        opinions contained herein (1) include the confidential and proprietary information of
        Morningstar Investment Management, (2) may include, or be derived from, account information
        provided by your financial advisor which cannot be verified by Morningstar Investment
        Management, (3) may not be copied or redistributed, (4) do not constitute investment advice
        offered by Morningstar Investment Management, (5) are provided solely for informational
        purposes and therefore are not an offer to buy or sell a security, and (6) are not warranted
        to be correct, complete or accurate. Except as otherwise required by law, Morningstar
        Investment Management shall not be responsible for any trading decisions, damages or other
        losses resulting from, or related to, this information, data, analyses or opinions or their
        use. Opinions expressed are as of the date written and are subject to change without notice
      </p>
      <p><strong>Disclaimers</strong></p>
      <p>
        Neither any Morningstar company nor any of their information providers can guarantee the
        accuracy, completeness, timeliness, or correct sequencing of any of the information on this
        website, including, but not limited to information originated by that Morningstar company,
        licensed by that Morningstar company from information providers, or gathered by that
        Morningstar company from publicly available sources. There may be delays, omissions, or
        inaccuracies in the information.
      </p>
      <p>
        NEITHER ANY OF THE MORNINGSTAR COMPANIES NOR ANY OF THEIR INFORMATION PROVIDERS SHALL HAVE
        ANY LIABILITY, CONTINGENT OR OTHERWISE FOR THE ACCURACY, COMPLETENESS, TIMELINESS, OR
        CORRECT SEQUENCING OF THE INFORMATION OR FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN
        RELIANCE UPON THE INFORMATION ON THIS WEBSITE, OR FOR INTERRUPTION OF ANY DATA, INFORMATION,
        OR ANY OTHER ASPECT OF THIS WEBSITE. THE PAST PERFORMANCE OF AN INVESTMENT OR INVESTMENT
        STRATEGY CANNOT GUARANTEE ITS FUTURE PERFORMANCE.
      </p>
      <p>
        NEITHER ANY OF THE MORNINGSTAR COMPANIES NOR ANY OF THEIR INFORMATION PROVIDERS MAKE ANY
        REPRESENTATIONS ABOUT THE SUITABILITY OF THE INFORMATION, SOFTWARE, PRODUCTS, OR SERVICES
        CONTAINED IN THIS WEBSITE. ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES ARE
        PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. PRODUCT SPECIFICATIONS AND PRICES ARE SUBJECT
        TO CHANGE WITHOUT NOTICE.
      </p>
    </div>
    <div v-if="data.index == 'privacy-policy'">
      <p><strong>General Morningstar Privacy Policy (Updated for GDPR 01 May 2018)</strong></p>
      <p>
        Morningstar, Inc., its Affiliates and Group Companies (individually and collectively,
        “Morningstar”) are committed to safeguarding your privacy.
      </p>
      <p>
        This General Privacy Policy outlines the types of information we collect from website
        visitors, clients, and other third parties. As Morningstar is a global company, certain
        supplemental local privacy policies and laws may apply to you depending on your citizenship
        and your rights and we would invite you to visit the local websites and view the additional
        privacy policies set out in the legal information section on those websites.
      </p>
      <p>
        In this Policy we set out how we use personal information, with whom we might share it, the
        means by which we keep it secure, and the choices you have about the information you choose
        to share with us.
      </p>
      <p>
        If You have any questions about the privacy practices of Morningstar or about this Privacy
        Policy, please send an email to corporatesite@morningstar.com in the first instance and Your
        questions will be directed to the appropriate team within Morningstar to deal with your
        enquiry.
      </p>
      <p><strong>Personal Information we collect and what we use it for</strong></p>
      <p>
        The types of personal information we collect depend on the purpose for which you provide it
        to us. We only collect what is necessary for the purposes set out in this General
        Morningstar Privacy Policy or in any local supplement or notice in a local website.
      </p>
      <p>Clients/authorized users</p>
      <p>
        We collect limited personal information such as name, email and in some cases your IP
        address, phone number and physical address from you as an authorised user or contact for our
        products and services and in some cases where you are paying for a subscription service we
        will collect credit card or payment details.
      </p>
      <p><strong>What we use it for</strong></p>
      <p>
        We use the personal information to administer and support the contracts we have with
        you/authorised users of our products and services you are obtaining from us. We use this
        information for the purpose of providing updates about these products and services, dealing
        with support, billing and inquiries and providing information about other products and
        services that may be if interest to you.
      </p>
      <p><strong>Site visitors</strong></p>
      <p>
        If you are accessing a Site to learn more about Morningstar and our products and services
        inquire about employment with a Morningstar company, subscribe to web services or access our
        research, the information we collect may include your name, physical and email addresses,
        and phone number(s) via one or more online registration forms. If you are subscribing to a
        web service with a subscription fee we also collect credit card or other payment details.
      </p>
      <p>
        For personal information submitted via our US Site, you consent to the collection and use of
        any personal information and any related information in the manner described in this Privacy
        Policy. For non-US Sites local regulation may be in place in respect of obtaining your
        consent to the collecting and processing of your data and you are advised to read the
        information relating to the local Sites and any revisions or supplements to this General
        Privacy Policy that may apply in your jurisdiction.
      </p>
      <p><strong>What we use it for</strong></p>
      <p>
        On our websites, we use the personal information (and any preferences indicated by you,
        where appropriate) to make available to you the investment information, tools and other
        requested information, free product trial, communication with sales, content or research, or
        information pertaining to a job posting you have requested. In some cases, we use the
        personal information to provide you on our Site with targeted third-party advertisements
        which may be of interest to you based on any preferences you have indicated in your
        registration form(s).
      </p>
      <p><strong>Links to other websites</strong></p>
      <p>
        Morningstar may provide links to one or more other third-party websites from the Sites. We
        encourage you to read those website’s individual privacy policies before providing any of
        Your personal information to them.
      </p>
      <p><strong>Suppliers</strong></p>
      <p>
        We collect limited personal information such as name, email and in some cases your IP
        address, phone number and postal business address from you as authorised users or contacts
        for our products and services.
      </p>
      <p><strong>What we use it for</strong></p>
      <p>
        We use the personal information to administer and support the contracts we have with you. We
        also use this information to contact you for dealing with support, billing and inquiries
        about your products and services.
      </p>
      <p><strong>Candidates</strong></p>
      <p>
        If you are accessing a Site to inquire about employment with a Morningstar company, the
        information may include, but is not limited to: your name, physical and email addresses, and
        phone number(s) and if you are submitting an employment application and related information
        through the Site, your user name/password and any additional employment-related information
        that you choose to provide.
      </p>
      <p><strong>What we use it for</strong></p>
      <p>
        We use this information to process and manage your application for employment with
        Morningstar.
      </p>
      <p>
        <strong
          >Personal information uploaded by clients or subscribers to Morningstar online tools or
          hosted solutions</strong
        >
      </p>
      <p>
        Some Morningstar tools or hosted solutions allow you to upload personal and other
        information about your employees, clients or other third parties into your instance of the
        tool or solution. In such cases you should therefore ensure you are compliant with the
        relevant local data protection regulations in respect of the personal information you input
        into the online tool. When you terminate your subscription or request that your personal
        data is deleted Morningstar will delete your instance of the tool including all of the
        information contained within it. Morningstar has no access to the personal data you upload
        into the tools and it is your obligation to ensure you have a backup of the data you have
        uploaded. Further information on your use of the tool and hosted solutions are set out in
        the Terms and Conditions and the relevant Product guide.
      </p>
      <p><strong>Personal information, how long do we keep it for?</strong></p>
      <p>
        Morningstar retains personal information only for as long as necessary for the uses we have
        set out above. Individual jurisdictions have different tax, accounting, regulatory and legal
        retention requirements and Morningstar is bound to keep certain personal information in
        accordance with these local requirements.
      </p>
      <p><strong>Personal Information: How we store and process it</strong></p>
      <p>
        All personal information we gather from you may be processed and stored in any one of our
        Group Company locations and may subsequently be transferred to other countries for further
        processing, storage, and/or use by Morningstar. Our staff who need to access personal
        information to perform their roles will have access to it and have agreed to comply with
        Morningstar’s policies on data protection.
      </p>
      <p>
        Morningstar uses a small number of third parties to provide systems and software for its
        administrative functions, such as sales processing, accounting / finance management and
        procurement. In such cases Morningstar remains controller of the personal information, the
        third parties only process the data in accordance with our instructions and we are
        responsible for ensuring such third parties are compliant with all applicable data
        protection regulations in relation to their processing activities.
      </p>
      <p><strong>Protection of your personal information</strong></p>
      <p>
        We have technical, security and organisational measures in place, (and require our service
        providers do so as well), to protect against unauthorized access to, or unauthorized
        alteration, disclosure, or destruction of personal information. The measures we use are
        appropriate to the nature, scope and purpose for which we use the personal information we
        collect. These measures include internal reviews of our data collection, storage, and
        processing practices and security measures, as well as physical security measures to guard
        against unauthorized access to systems where we store personal data. We have recently
        updated our processes to ensure we can comply with data subject requests as required under
        applicable law, to address complaints and comply with breach reporting procedures and
        incident management plans.
      </p>
      <p>
        Morningstar operates secure data networks protected by industry-standard firewall and
        password protection systems. Our security and privacy policies are periodically reviewed and
        enhanced as necessary and only authorized individuals have access to the information
        provided.
      </p>
      <p>
        Further information on our security and incident management is available from
        infosec@morningstar.com.
      </p>
      <p><strong>Use of cookies on our Sites and in Morningstar products</strong></p>
      <p>
        We use cookies to set user preferences such as email and, if applicable password. This
        information allows us to personalize the user experience and improve the quality of our Site
        navigation and products. Information about the cookies on our Sites, where required is
        available on the Site.
      </p>
      <p><strong>How to update your personal information or make a data subject request</strong></p>
      <p><strong>Site visitors</strong></p>
      <p>
        If you need to update your preferences or information or make a data subject request, you
        need only email us at corporatesite@morningstar.com or follow the instructions contained in
        any email we have sent to you to unsubscribe or change your preferences.
      </p>
      <p><strong>Clients / Suppliers</strong></p>
      <p>
        If you need to update your information or make a data subject request, please email us
        either at the local contact details set out in the supplemental local policies on your local
        website or at corporatesite@morningstar.com in the first instance and we will direct your
        enquiries to the appropriate team within Morningstar to action.
      </p>
      <p><strong>Employment candidates</strong></p>
      <p>
        Questions related to your personal information submitted as an application for employment
        inquiries you’ve made or job applications you’ve submitted should be sent to:
        AskHR@morningstar.com.
      </p>
      <p><strong>What About children’s privacy?</strong></p>
      <p>
        Morningstar does not separately identify, or collect, any information that is specific to
        children.
      </p>
      <p><strong>Data Subject Requests</strong></p>
      <p>
        Certain local regulations grant individuals in those locations certain rights in respect of
        their personal information held by companies. If you wish to make a Data Subject Request,
        You should contact corporatesite@morningstar.com in the first instance and your email will
        be directed to the correct Morningstar team to take action with respect to your request.
      </p>
      <p><strong>Your consent to collection and use of personal data</strong></p>
      <p>
        Under the laws of the USA, by continuing to use a Site, we can take that as your consent to
        the collection and use of any personal information and any related information in the manner
        described in this General Privacy Policy.
      </p>
      <p>
        If you are not a US citizen, local regulation may be in place in respect of obtaining your
        consent to the collecting and processing of your data and you are advised to go to the Site
        which is appropriate to your citizenship and read the information relating to the local Site
        and any supplemental privacy policy that may apply in your jurisdiction.
      </p>
      <p><strong>Changes to the Privacy Policy</strong></p>
      <p>
        Morningstar reserves the right to change this General Privacy Policy and any supplemental
        local privacy policies at any time by distributing and/or posting a new Privacy Policy
        without notice. We encourage you to review our General Privacy Policy and any local privacy
        policies on a regular basis so that you will be aware of any changes to it.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pages',
  props: {
    data: {
      type: Object,
      default() {
        return {
          index: '',
        };
      },
    },
  },
};
</script>

<style lang="scss">
.pages-container {
  p {
    font-family: $mds-font-family-sans-serif;
  }
}
</style>
